import { render, staticRenderFns } from "./modNavCtrA.vue?vue&type=template&id=31658a44&"
import script from "./modNavCtrA.vue?vue&type=script&lang=js&"
export * from "./modNavCtrA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports